<div class="position-relative w-100 hero-section">
  <img [src]="imageUrl + config.bannerImageUrl" class="w-100 hero-img" alt="Sports Shirt" />

  <div class="overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center">
    <div class="content text-white">
      <div class="d-flex flex-wrap flex-column gap-4">
        <h1 class="highlight-box mb-0">{{ firstHalfText }}</h1>
        <h1 class="highlight-box mb-0">{{ secondHalfText }}</h1>
      </div>
      <button id="customizeNowButton" class="btn customize-btn mt-5" routerLink="/customization">
        {{ config.bannerButtonText || 'CUSTOMIZE NOW' }}
      </button>
    </div>
  </div>
</div>